export type PaidTier = 'artist' | 'studio';

export const STRIPE_PRICE_IDS = {
  artist: import.meta.env.VITE_STRIPE_ARTIST_PRICE_ID as string,
  artistCloud: import.meta.env.VITE_STRIPE_ARTIST_CLOUD_PRICE_ID as string,
  studio: import.meta.env.VITE_STRIPE_STUDIO_PRICE_ID as string,
  studioCloud: import.meta.env.VITE_STRIPE_STUDIO_CLOUD_PRICE_ID as string,
} as const;

export const TIER_BASE_PRICES: Record<PaidTier, number> = {
  artist: 5,
  studio: 25,
};

export function priceIdForTier(tier: PaidTier, includesCloud: boolean): string {
  if (tier === 'artist') {
    return includesCloud ? STRIPE_PRICE_IDS.artistCloud : STRIPE_PRICE_IDS.artist;
  }
  return includesCloud ? STRIPE_PRICE_IDS.studioCloud : STRIPE_PRICE_IDS.studio;
}

export function displayPriceForTier(tier: PaidTier, includesCloud: boolean): number {
  const base = TIER_BASE_PRICES[tier];
  return includesCloud ? base * 2 : base;
}
